import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfileBlurb.scss'
import { Row, Col } from 'react-bootstrap'
import PropTypes from 'prop-types';

class AdviserProfileBlurb extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    children: PropTypes.object,
    compact: PropTypes.bool,
    more: PropTypes.bool
  };

  render () {
    const compact = this.props.compact
    const profile = this.props.profile
    let website = profile.companyWebsite
    if (profile.companyWebsite && profile.companyWebsite.indexOf('http://') < 0 && profile.companyWebsite.indexOf('https://') < 0) {
      website = `http://${website}`
    }
    let jobTitle = ''
    if (profile.title) {
      jobTitle += profile.title
    }
    if (profile.company) {
      jobTitle += ' at ' + profile.company
    }

    let overflowControlStyle = ''
    let adviserBlurbSummary = ''
    let adviserBlurbSummaryDiv = ''
    if (this.props.more) {
      adviserBlurbSummary = styles['adviser-blurb-summary']
      overflowControlStyle = styles['overflow-single-line']
      adviserBlurbSummaryDiv = styles['adviser-blurb-summary-div']
    } else {
      adviserBlurbSummary = styles['adviser-blurb']
      adviserBlurbSummaryDiv = ''
    }

    let address = profile.buildingDetails ? profile.buildingDetails + ', ' : ''
    address += profile.streetAddress ? profile.streetAddress + ', ' : ''
    address += profile.suburb ? profile.suburb + ', ' : ''
    address += profile.postalCode ? profile.postalCode + ', ' : ''
    address += profile.city ? profile.city : ''

    let displayAddress = <div className={styles['adviser-company-address'] + ' ' + overflowControlStyle}>{address}</div>
    let jobTitleEl = <div className={styles['adviser-job-title'] + ' ' + overflowControlStyle}> {jobTitle} </div>

    let websiteEl = <a
      className={styles['adviser-company-website']}
      href={website}
      target='blank'>
      {profile.companyWebsite}
    </a>

    const blankProfile = !(jobTitle || profile.companyAddress || profile.blurb || profile.companyWebsite)

    let qaTag = 'Searchresult-' + profile.firstName + ' ' + profile.lastName + '-heading'
    return (
      <div>
        <Row>
          <Col sm={9} md={9} lg={9} xs={12}>
            <h3 data-qa={qaTag} className={styles['adviser-name']}> {profile.firstName} {profile.lastName}</h3>
          </Col>
          <Col sm={3} md={3} lg={3} className="d-none d-sm-block">
            {!this.props.more ? this.props.children : ''}
          </Col>
        </Row>
        {jobTitleEl}
        <div>
          {websiteEl}
        </div>
        {!compact ? displayAddress : ''}
        {!compact && <div className={adviserBlurbSummaryDiv}>
          <p className={adviserBlurbSummary}>{profile.blurb}</p>
        </div>}
        {blankProfile && <p className={styles['blank-profile-message']}>
          Welcome{profile.adviserName ? ' ' + profile.adviserName : ''}, it looks like your profile is empty.
          <br />
          Click the red {this.props.children} links to begin.
          </p>}
      </div>
    )
  }

}

export default (AdviserProfileBlurb)
